import React from 'react';
import { AlertTriangleIcon, DollarSignIcon, ClockIcon, CreditCardIcon } from 'lucide-react';
export function TrustSection() {
  const stats = [{
    icon: AlertTriangleIcon,
    stat: '$3.4B',
    label: 'Lost to Fraud',
    description: 'Adults over 60 lost $3.4 billion to fraud in 2023 alone.'
  }, {
    icon: DollarSignIcon,
    stat: '$83,000+',
    label: 'Average Loss',
    description: 'The average loss per incident for victims over 60.'
  }, {
    icon: ClockIcon,
    stat: '3-5 hrs',
    label: 'Monthly Hidden Tax',
    description: 'Time the average "Family IT person" spends on unpaid tech support.'
  }, {
    icon: CreditCardIcon,
    stat: '$400-700',
    label: 'Wasted Annually',
    description: 'What households pay in redundant security and cloud services.'
  }];
  return <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-395">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-396">
        <div className="text-center mb-16" data-id="element-397">
          <h2 className="text-3xl md:text-5xl font-bold text-[#111111] mb-6" data-id="element-398">
            This Isn't Hypothetical — It's Happening to Families Like Yours
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-399">
            The people getting hurt aren't careless. They just never had anyone
            explain the risks in a way that made sense.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-400">
          {stats.map((item, index) => <div key={index} className="bg-[#f8f8f8] rounded-2xl p-6 border-2 border-gray-200 text-center" data-id="element-401">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center mx-auto mb-4 border border-[#631bb7] border-opacity-10" data-id="element-402">
                <item.icon className="w-6 h-6 text-[#631bb7]" data-id="element-403" />
              </div>
              <div className="text-3xl md:text-4xl font-extrabold text-[#111111] mb-1" data-id="element-404">
                {item.stat}
              </div>
              <div className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-3" data-id="element-405">
                {item.label}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-406">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}